import { combineReducers } from "redux";
import ProfileReducer from "./profile/reducer";

const RootReducers = combineReducers({
  ProfileReducer,
});

export default RootReducers;
